var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocial4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18642",
    "data-name": "Rectangle 18642",
    width: 22,
    height: 22,
    transform: "translate(756 4167)",
    fill: "#a5a5a5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_51",
    "data-name": "Mask Group 51",
    transform: "translate(-756 -4167)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215691",
    "data-name": "Path 215691",
    d: "M25.619,9.041,33.4,0H31.554L24.8,7.85,19.406,0H13.185l8.157,11.871-8.157,9.481h1.843l7.132-8.29,5.7,8.29h6.221L25.619,9.041Zm-2.525,2.934-.826-1.182L15.692,1.388h2.831L23.83,8.978l.826,1.182,6.9,9.867H28.724l-5.629-8.052Z",
    transform: "translate(743.574 4167)",
    fill: "#a5a5a5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial4);
export default __webpack_public_path__ + "static/media/social4.94d551e6f252ebf9da513f719613e12a.svg";
export { ForwardRef as ReactComponent };